import Button from '@loggi/ui/components/button';
import Col from '@loggi/ui/components/col';
import Divider from '@loggi/ui/components/divider';
import Icon from '@loggi/ui/components/icon';
import Text from '@loggi/ui/components/text';
import colors from '@loggi/ui/components/utils/colors';
import icons from '@loggi/ui/components/utils/icons';
import PropTypes from 'prop-types';
import React, { Fragment, PureComponent } from 'react';
import {
  DISPLAY_DATA_DIVIDER_ID,
  DISPLAY_DATA_LABEL_ID,
  DISPLAY_DATA_SEE_MORE_BUTTON_ID,
  DISPLAY_DATA_TOGGLE_CHILD_BUTTON_ID,
  PROPS_ERROR_MESSAGE
} from './display-data.constants';
import styles from './display-data.styles.scss';

export default class DisplayData extends PureComponent {
  static displayName = 'DisplayData';

  static propTypes = {
    mainData: PropTypes.string,
    icon: PropTypes.string,
    label: PropTypes.string,
    hasDivider: PropTypes.bool,
    actionButton: PropTypes.shape({
      icon: PropTypes.string,
      click: PropTypes.func,
      dataTestId: PropTypes.string
    }),
    children: PropTypes.node,
    hasSeeMoreButton: PropTypes.bool
  };

  static defaultProps = {
    mainData: null,
    label: null,
    hasDivider: false,
    actionButton: null,
    children: null,
    icon: null,
    hasSeeMoreButton: false
  };

  constructor(props) {
    super(props);

    this.state = {
      open: false,
      shouldRenderSeeMoreButton: props.hasSeeMoreButton,
      seeMore: props.hasSeeMoreButton
    };

    this.mainDataText = React.createRef();
  }

  componentDidMount() {
    const { hasSeeMoreButton, mainData } = this.props;
    if (hasSeeMoreButton && mainData)
      this.setState({
        shouldRenderSeeMoreButton: this._mainDataTextHasOverflowEllipsis()
      });
  }

  _mainDataTextHasOverflowEllipsis = () => {
    const {
      current: {
        textRef: {
          current: { offsetWidth, scrollWidth }
        }
      }
    } = this.mainDataText;

    return offsetWidth < scrollWidth;
  };

  _toggleChildContent = () => {
    const { open } = this.state;

    this.setState({ open: !open });
  };

  _toggleMainInfo = () => {
    const { seeMore } = this.state;

    this.setState({ seeMore: !seeMore });
  };

  render() {
    const {
      mainData,
      actionButton,
      children,
      label,
      hasDivider,
      icon
    } = this.props;
    const { open, shouldRenderSeeMoreButton, seeMore } = this.state;

    if (actionButton && children) {
      throw new Error(PROPS_ERROR_MESSAGE);
    }

    const displayDataClassName =
      label && mainData
        ? `${styles.displayDataContainer} ${styles.hasLabelAndData}`
        : styles.displayDataContainer;

    return (
      <Fragment>
        {hasDivider && (
          <Col gutter={{ top: 'normal', bottom: 'normal' }}>
            <Divider
              data-testid={DISPLAY_DATA_DIVIDER_ID}
              color={colors.type.SMOKE_100}
            />
          </Col>
        )}
        <Col className={`${displayDataClassName}`}>
          {icon && <Icon type={icon} color={colors.type.STORM_500} />}
          <Col
            className={seeMore ? 'see-more main-info' : 'main-info'}
            gutter={{ left: 'normal' }}
          >
            {label && (
              <Text
                data-testid={DISPLAY_DATA_LABEL_ID}
                size="300"
                color={colors.type.SMOKE_900}
              >
                {label}
              </Text>
            )}
            {mainData && (
              <Text
                ref={this.mainDataText}
                size="300"
                color={colors.type.STORM_500}
              >
                {mainData}
              </Text>
            )}
            {shouldRenderSeeMoreButton && (
              <Button
                data-testid={DISPLAY_DATA_SEE_MORE_BUTTON_ID}
                icon={seeMore ? icons.type.DOWN : icons.type.UP}
                value={seeMore ? 'Ver mais' : 'Ver menos'}
                style="link"
                onClick={this._toggleMainInfo}
              />
            )}
            {children && (
              <Col className={open ? 'opened' : 'closed'}>{children}</Col>
            )}
          </Col>
          {children && (
            <Button
              data-testid={DISPLAY_DATA_TOGGLE_CHILD_BUTTON_ID}
              style="link"
              size="small"
              shape="circle"
              icon={open ? icons.type.UP : icons.type.DOWN}
              onClick={this._toggleChildContent}
            />
          )}
          {actionButton && (
            <Button
              data-testid={actionButton.dataTestid}
              style="outline"
              size="small"
              shape="circle"
              icon={actionButton.icon}
              onClick={actionButton.click}
            />
          )}
        </Col>
      </Fragment>
    );
  }
}
